import { DynamicHelmet } from "@interfaces/misc"
import MiscRepo from "@lib/api/server-side//misc.repository"
import CategoryRepository from "@lib/api/server-side/category.repository"
import RisebinarRepository from "@lib/api/server-side/risebinar.repository"
import { GetStaticProps } from "next"
import RisebinarListPage from "../modules/risebinar-list/RisebinarListPage"

export const getStaticProps: GetStaticProps = async () => {
  const category = new CategoryRepository()
  const misc = new MiscRepo()
  const risebinar = new RisebinarRepository()

  try {
    const res = category.getRawCategory()
    const res2 = misc.getMetaTag("risebinar")
    const res3 = risebinar.getRawRisebinarList()

    let categories = []
    let initialData = []
    let dynamicMeta: DynamicHelmet | null = null

    const [ctg, meta, risebinars] = await Promise.all([res, res2, res3])

    if (ctg.statusCode === 200) {
      const data = JSON.parse(ctg.body)
      categories = data.result
    }

    if (meta.statusCode === 200) {
      const data = JSON.parse(meta.body)
      dynamicMeta = data.result
    }

    if (risebinars.statusCode === 200) {
      const data = JSON.parse(risebinars.body)
      initialData = data.result.data
    }

    return {
      props: {
        categories,
        meta: dynamicMeta,
        initialData,
      },
    }
  } catch (e) {
    console.log(e)
    return {
      props: {
        categories: [],
        meta: null,
      },
    }
  }
}

export default RisebinarListPage
